class payment {
  constructor(msg) {
    console.log("payment  ==>", msg);

    const price = Math.round(msg.result.finalPKR);
    this.price = Number(price);
    this.items = {
      id: 30003,
      name: "calladoc",
      type: "payment",
      options: [],
      backtostart: true,
      text: [],
      slideimg: "/doctorassistant/dia.jpg",
      issuccess: false,
    };
  }

  async getAllItems(price, pid) {
    const item = sessionStorage.getItem("user");
    const TRAVEL_API_BASE =
      "https://miniappeasypaisa.webddocsystems.com/public/api/v1";

    try {
      const form = new FormData();
      form.append("value", this.price);
      form.append("apikey", "Travel");
      const response = await fetch(`${TRAVEL_API_BASE}/create-payment`, {
        method: "POST",
        body: form,
      });
      const res = await response.json();
      this.items.issuccess = true;
      this.items.text = [
        `<p class="text-success fw-bold">✅ Plan Activated Successfully!</p>
   <p>Your travel insurance is now active and ready to protect you throughout your journey.</p>
   <p class="mb-0">Have a safe and worry-free trip! ✈️</p>`,
      ];
      console.log("res =>", res);
      if (res.paymentTransactionID) {
        window.mp.createPayment(res.paymentTransactionID);
      }
    } catch (error) {
      console.error("Payment error:", error);
    } finally {
      return this.items;
    }
  }

  getPackageOptions() {
    return [
      {
        id: 70,
        text: "1 month package",
        name: "1 Month package",
        price: "150",
        type: "payment",
        desc: "<p>Unlock the ultimate convenience with unlimited audio and video consultations, giving you direct access to expert care &ndash; tailored to fit your busy lifestyle!</p>",
      },
      {
        id: 72,
        text: "12 month package",
        name: "12 Month package",
        price: "999",
        type: "payment",
        desc: "<p>Enjoy unlimited audio and video consultations for your entire family, providing you with expert care, all from the comfort of home!</p>",
      },
    ];
  }
}

export default payment;
